import { BusinessSettings } from "../core/interface";

const permissions:string[] = [];
var businessSettings:BusinessSettings=null;
export const setPermissions = (perms: string[]): void => {
    permissions.length = 0; // Clear the existing array
    permissions.push(...perms??[]); // Add new permissions
    }

export const hasPermission = (permission: string): boolean => {
  return permissions.includes(permission);
};
export const hasAnyPermission = (permissionsList: string[]): boolean => {
  if (!permissionsList || permissionsList.length === 0) return false;
  return permissionsList.some(permission => permissions.includes(permission));
}

export class Permission{
   static UserView = "User.View";  
    static UserEdit = "User.Edit";
    static UserDelete = "User.Delete";
    static UserAdd = "User.Add";
    static SaleInvoiceView = "SaleInvoice.View";
    static SaleInvoiceEdit = "SaleInvoice.Edit";
    static SaleInvoiceDelete = "SaleInvoice.Delete";
    static SaleInvoiceAdd = "SaleInvoice.Add";
    static PurchaseInvoiceView = "PurchaseInvoice.View";
    static PurchaseInvoiceEdit = "PurchaseInvoice.Edit";
    static PurchaseInvoiceDelete = "PurchaseInvoice.Delete";
    static PurchaseInvoiceAdd = "PurchaseInvoice.Add";
    static SaleDraftView = "SaleDraft.View";
    static SaleDraftEdit = "SaleDraft.Edit";
    static SaleDraftDelete = "SaleDraft.Delete";
    static SaleDraftAdd = "SaleDraft.Add";
    static ExpenseView = "Expense.View";
    static ExpenseEdit = "Expense.Edit";
    static ExpenseDelete = "Expense.Delete";
    static ExpenseAdd = "Expense.Add";
    static PayoutAdd = "Payout.Add";
    static PayoutEdit = "Payout.Edit";
    static PayoutDelete = "Payout.Delete";
    static PayoutView = "Payout.View";
    static ProductView = "Product.View";
    static ProductEdit = "Product.Edit";
    static ProductDelete = "Product.Delete";
    static ProductAdd = "Product.Add";
    static CompanyView = "Company.View";
    static CompanyEdit = "Company.Edit";

    static CompanyDelete = "Company.Delete";
    static CompanyAdd = "Company.Add";
    static CategoryView = "Category.View";
    static CategoryEdit = "Category.Edit";
    static CategoryDelete = "Category.Delete";
    static CategoryAdd = "Category.Add";
    static ExpenseTypeView = "ExpenseType.View";
    static ExpenseTypeEdit = "ExpenseType.Edit";
    static ExpenseTypeDelete = "ExpenseType.Delete";
    static ExpenseTypeAdd = "ExpenseType.Add";
    static CustomerView = "Customer.View";
    static CustomerEdit = "Customer.Edit";
    static CustomerDelete = "Customer.Delete";
    static CustomerAdd = "Customer.Add";
    static SupplierView = "Supplier.View";
    static SupplierEdit = "Supplier.Edit";
    static SupplierDelete = "Supplier.Delete";
    static SupplierAdd = "Supplier.Add";
    static StocksView = "Stocks.View";
    static TrackingView = "Tracking.View";
    static TrackingIngest = "Tracking.Ingest";
    }
